import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import sidebar from './modules/sidebar'
import modal from './modules/modal'
import detail from './modules/detail'
import work from './modules/work'
import ldap from './modules/ldap'
import remediation from './modules/remediation'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    auth,
    sidebar,
    modal,
    detail,
    work,
    ldap,
    remediation
  },
  state: {
    darkTheme: true
  },
  getters: {
    state: (state) => state
  },
  mutations: {
    initialiseStore (state) {
      // Vérifie si le state seenComments existe dans le localstorage
      if (localStorage.getItem('seenComments')) {
        Object.assign(state.work.seenComments, JSON.parse(localStorage.getItem('seenComments')))
      }
      // Vérifie si le state  darkTheme existe dans le localstorage
      if (localStorage.getItem('darkTheme')) {
        // localstorage ne stocke que des strings, conversion en bool
        let value = (localStorage.getItem('darkTheme') === 'true')
        state.darkTheme = value
      } else {
        // Le darktheme est activé de base
        localStorage.setItem('darkTheme', true)
      }
    },
    toggleDarkTheme (state) {
      let value = !state.darkTheme
      state.darkTheme = value
      localStorage.setItem('darkTheme', value)
    }
  },
  actions: {
    initialiseStore ({ commit }) {
      commit('initialiseStore')
    },
    toggleDarkTheme ({ commit }) {
      commit('toggleDarkTheme')
    }
  }
})
// Subscribe aux màj du state seenComments
store.subscribe((mutation, state) => {
  if (mutation.type === 'work/addSeenComments' || mutation.type === 'work/removeSeenComment' || mutation.type === 'work/resetSeenComment') {
    localStorage.setItem('seenComments', JSON.stringify(state.work.seenComments))
  }
})

export default store
